import {SxProps} from "@mui/system";

export const mergeSx = (sx?: SxProps) => (Array.isArray(sx) ? sx : [sx])
